import React from "react";

const Status = (props) => {
  return (
    <div className="box">
      <h2>Sensor status </h2>
      <div>
        {4 > 3 ? (
          <div>
            <h1 className="green">ON</h1>
          </div>
        ) : (
          <h1 className="blue">OFF</h1>
        )}
      </div>
    </div>
  );
};

export default Status;
